/**
 * Inject a JSON-LD block into <head> for the life of a page.
 *
 * The pre-Bloom pages did this with react-helmet-async. That is not a
 * dependency here — `SEO` drives the head through the `useSEO` hook instead —
 * and pulling in a whole head manager for one script tag is a poor trade.
 *
 * Dropping the structured data instead was the other option, and worse: it is
 * what tells a search engine that a page is an Article or a FAQ rather than
 * prose, and losing it silently during a port is the kind of regression nobody
 * notices for months.
 */
import { useEffect } from 'react';

export function StructuredData({ data }: { data: unknown }) {
  useEffect(() => {
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.textContent = JSON.stringify(data);
    document.head.appendChild(el);

    // Removed on unmount so a client-side navigation does not leave the
    // previous page's schema behind, describing something no longer on screen.
    return () => { el.remove(); };
  }, [data]);

  return null;
}
